import { useState as O, useRef as g, useCallback as p, useEffect as P } from "react";
import { onKeyDownEnterAndSpace as N } from "./index.es526.js";
const h = /* @__PURE__ */ new Map(), K = (d, c, T, M) => {
  const [b, q] = O(!1), y = g(null), I = g(!1), E = g(!1), B = g(0), f = g(!1), i = g(!1), m = p(() => {
    if (y.current && document.contains(y.current))
      return y.current;
    const e = [
      'button[data-ref="eFilterButton"]',
      ".ag-header-cell-filter-button",
      'button[aria-label*="Filter"]'
    ];
    for (const o of e) {
      const r = document.querySelector(o);
      if (r)
        return y.current = r, r;
    }
    return null;
  }, [M]), C = p((e) => {
    const o = document.querySelector(`[col-id="${e}"]`);
    if (o) {
      const n = o.querySelector(
        ".ag-header-cell-filter-button"
      ) || o.querySelector(
        'button[data-ref="eFilterButton"]'
      );
      if (n) return n;
    }
    const r = [
      `[data-testid*="${e}"][data-testid*="filter-button"]`,
      `[data-testid*="${e}-filter-button"]`,
      `button[aria-label*="Filter"][aria-label*="${e}"]`
    ];
    for (const n of r)
      try {
        const u = document.querySelector(n);
        if (u) return u;
      } catch {
        continue;
      }
    const s = document.querySelectorAll(
      'button[data-ref="eFilterButton"], button[class*="filter-button"]'
    );
    for (const n of s) {
      const u = n.getAttribute("aria-label") || "", k = n.getAttribute("data-testid") || "";
      if (u.toLowerCase().includes(e.toLowerCase()) || k.toLowerCase().includes(e.toLowerCase()))
        return n;
    }
    return null;
  }, []), v = p(
    (e = !0) => {
      var r;
      if (document.querySelectorAll(".ag-filter-popup, .ag-menu, .ag-popup").forEach((s) => {
        s.style.display = "none";
      }), (r = d.hidePopupMenu) == null || r.call(d), q(!1), e) {
        if (I.current = !1, E.current = !1, i.current = !1, c) {
          const n = `reopen-${c.getColId()}`, u = h.get(n);
          u && (clearTimeout(u), h.delete(n));
        }
        const s = m();
        s && setTimeout(() => s.focus(), 100);
      }
    },
    [d, m, c]
  ), A = p(() => {
    const e = m();
    e && (q(!0), I.current = !0, T(e));
  }, [T, m]), x = p(() => {
    if (!c || i.current) return;
    const e = c.getColId(), o = `reopen-${e}`, r = h.get(o);
    r && clearTimeout(r);
    const s = setTimeout(() => {
      if (h.delete(o), i.current) return;
      const n = C(e);
      n && (n.click(), E.current = !0, setTimeout(() => {
        E.current = !1;
      }, 1e3));
    }, 800);
    h.set(o, s);
  }, [c, C]), L = p(
    (e) => {
      c && (e == null || e.stopPropagation(), b ? v(!0) : A());
    },
    [c, b, v, A]
  );
  P(() => {
    if (!d || !c) return;
    const e = (l) => {
      if (l.column === c && I.current) {
        const t = Date.now(), a = t - B.current;
        if (B.current = t, a < 100 && !f.current) {
          f.current = !0, setTimeout(() => {
            f.current = !1;
          }, 500);
          return;
        }
        !f.current && !i.current && x();
      }
    }, o = (l) => {
      l.key === "Escape" && b && v(!0);
    }, r = (l) => {
      if (!b || E.current) return;
      const t = l.target, a = m(), F = document.querySelector(".ag-filter-popup, .ag-menu, .ag-popup"), S = a == null ? void 0 : a.contains(t), w = F == null ? void 0 : F.contains(t);
      if (w) {
        const $ = t.closest(
          '.ag-list-item, .ag-virtual-list-item, [role="option"]'
        ), R = t.closest("select") || t.matches("select, option") || t.closest(".ag-picker-field, .ag-select") || t.closest('[class*="select"], [class*="dropdown"]');
        if ($ && (f.current = !0, setTimeout(() => {
          f.current = !1;
        }, 500)), R) {
          i.current = !0, setTimeout(() => {
            i.current = !1;
          }, 2e3);
          return;
        }
      }
      if (!S && !w) {
        v(!0);
        return;
      }
    }, s = () => {
      f.current = !1, i.current = !1;
    }, n = (l) => {
      const t = l.target, a = document.querySelector(".ag-filter-popup, .ag-menu, .ag-popup");
      if (a != null && a.contains(t)) {
        const F = t.matches('input[type="text"], input[type="search"], textarea') || t.tagName === "INPUT" && !t.getAttribute("type"), S = t.matches("select, option") || t.closest("select");
        F || (i.current = !0, setTimeout(() => {
          i.current = !1;
        }, S ? 2500 : 1500));
      }
    };
    d.addEventListener("filterModified", e), document.addEventListener("keydown", o), document.addEventListener("click", r, !0), document.addEventListener("change", n, !0), document.addEventListener("input", n, !0);
    const u = () => {
      document.querySelectorAll('.ag-filter-popup input[type="text"]').forEach((t) => {
        t.addEventListener("input", s), t.addEventListener("keydown", s);
      });
    };
    u();
    const k = setInterval(u, 100);
    return () => {
      clearInterval(k), d.removeEventListener("filterModified", e), document.removeEventListener("keydown", o), document.removeEventListener("click", r, !0), document.removeEventListener("change", n, !0), document.removeEventListener("input", n, !0), document.querySelectorAll('.ag-filter-popup input[type="text"]').forEach((t) => {
        t.removeEventListener("input", s), t.removeEventListener("keydown", s);
      });
    };
  }, [d, c, b, v, m, x]);
  const D = p(
    (e) => {
      N(e, () => L(), !0, !1);
    },
    [L]
  );
  return {
    filterButtonRef: y,
    onFilterButton: L,
    onFilterKeydown: D
  };
};
export {
  K as useBaseHeaderFilterState
};
//# sourceMappingURL=index.es5660.js.map
